import { useId, useState } from 'react';
import type { FaqItemData } from '../../content/finalPageData';
import { analyticsGoals, trackAnalyticsGoal } from '../../lib/analytics/yandexMetrika';
import styles from './FaqSection.module.scss';

interface FaqItemProps {
  item: FaqItemData;
  index: number;
}

export function FaqItem({ item, index }: FaqItemProps) {
  const [isOpen, setIsOpen] = useState(index === 0);
  const answerId = useId();

  const toggle = () => {
    setIsOpen((value) => {
      if (!value) trackAnalyticsGoal(analyticsGoals.faqOpen, { faq_id: item.id });
      return !value;
    });
  };

  return (
    <article className={styles.item}>
      <h3 className={styles.questionHeading}>
        <button
          className={styles.summary}
          type="button"
          aria-expanded={isOpen}
          aria-controls={answerId}
          onClick={toggle}
        >
          <span className={styles.number} aria-hidden="true">
            {String(index + 1).padStart(2, '0')}
          </span>
          <span className={styles.question}>{item.question}</span>
          <span className={styles.indicator} aria-hidden="true" />
        </button>
      </h3>
      <div
        id={answerId}
        className={`${styles.answer} ${isOpen ? styles.answerOpen : ''}`}
        aria-hidden={!isOpen}
      >
        <div className={styles.answerInner}>
          <p>{item.answer}</p>
        </div>
      </div>
    </article>
  );
}
